





















import { computed, defineComponent } from '@vue/composition-api';
export default defineComponent({
  name: 'TtamExistingAdGroup',
  props: {
    value: {
      type: [Number, String],
      required: true,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const labelKey = (item: { adName: string; adId: number | string }) => `${item.adName} (${item.adId})`;
    const _adId = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });

    return {
      _adId,
      labelKey,
    };
  },
});
